import React from 'react';

import { TerrainModel } from '../../../../../../viewer/elements/terrain-model';
import { useNonce } from '../../../../../hooks/use-nonce';
import { useAsset } from '../../../hooks/use-asset';
import { AssetVolumes } from '../../components/asset-volume/asset-volumes';
import { OpacitySection } from '../../components/opacity-section';
import { FullWidth } from '../../styles/grid';

type Props = {
  asset: TerrainModel;
};

const TerrainModelBody = (props: Props) => {
  const [_, refresh] = useNonce();

  useAsset(props.asset, {
    onAssetChanged: refresh,
  });

  return (
    <>
      <FullWidth>
        <OpacitySection asset={props.asset} />
      </FullWidth>

      <FullWidth>
        <AssetVolumes asset={props.asset} />
      </FullWidth>
    </>
  );
};

export { TerrainModelBody, Props as TerrainModelBodyProps };
